import { EStripeSubStatus } from '../../../models/consts';
import { IGithubUser, ITrialDataAPI } from '../../../models/models';
import { EGithubPlanNames } from '../../../models/paymentPlans/github-payments-plan';
import { ENotionPlanNames, notionPlans } from '../../../models/paymentPlans/notion-payments-plan';
import { trialDaysFinishDate } from '../../../utils/trialDaysLeft';
import {shopifyEntitiesAdapterFunc, shopifyUserAdapterFunction} from '../../functions';

export const fetchShopifyUserAction = (state, { payload }) => {
  if (!payload) {
    state.shopify.usersLoading = false;
    state.shopify.users = [];
    return;
  }
  state.shopify.usersLoading = false;
  state.shopify.users = shopifyUserAdapterFunction(payload);
}

export const addShopifyUserAction = (state, { payload }) => {
  if (payload) {
    state.shopify.users = shopifyUserAdapterFunction([payload] as Array<IGithubUser>);
  }
}

export const clearShopifyItemsList = (state) => {
  state.shopify.itemsLoading = true;
  state.shopify.items = null;
  state.shopify.totalItems = 0;
}

export const fetchEntityForShopifyUserAction = (state, { payload }) => {
  state.shopify.itemsLoading = false;
  const items = payload?.currentCustomers || payload?.currentProducts || payload?.currentOrders || []
  state.shopify.items = shopifyEntitiesAdapterFunc(!!items.length ? items : []);
  state.shopify.canUserBackup = payload.canUserBackup;
  state.shopify.totalItems = payload.totalItemsNumber;
}

export const checkShopifyTrialStatusAction = (state, { payload }) => {
  if (payload) {
    state.shopify.isConnectionActive = !!payload.isConnectionActive

    const trialData = payload as ITrialDataAPI;
    state.shopify.trial = {
      trialStatus: trialData.trialStatus,
      finishDate: trialDaysFinishDate(trialData.trialHoursLeft),
      trialHoursLeft: trialData.trialHoursLeft,
      availableItemsQuantity: trialData.availableItemsQuantity,
      addedItemsQuantity: trialData.addedItemsQuantity || (payload.isConnectionActive ? 1 : 0),
      payItemsQuantity: trialData.ordersPrevMonth,
      planQuantity: trialData.trialDefaultQuantity,
      isInvoiceRequested: trialData.stripe_shopify_subscription_bank_transfer_requested || false,
      isCancel: false
    };

    const {s3_region, cloud_storages, ordersPrevMonth, stripe_shopify_next_invoice, subscription_type, subscription_period, stripe_shopify_subscription_cancel_at_period_end, stripe_shopify_orders_quantity, stripe_shopify_orders_bought_quantity, stripe_shopify_subscription_status, availableItemsQuantity, addedItemsQuantity, stripe_shopify_subscription_bank_transfer_requested, stripe_shopify_subscription_current_period_end } = trialData;

    if (stripe_shopify_orders_bought_quantity) {
      state.shopify.trial.payItemsQuantity = stripe_shopify_orders_bought_quantity
    }

    state.shopify.storage = cloud_storages || []
    if (s3_region) {
      state.shopify.regionS3 = s3_region
    }

    if (stripe_shopify_subscription_status === 'active') {
      const planData = notionPlans.find(({ name }) => name === ENotionPlanNames.ESSENTIAL);
      const isAnnual = subscription_period && subscription_period === 'year' || planData?.stripeIds.yearly === trialData.stripe_shopify_price_id;

      const cost = stripe_shopify_next_invoice ? stripe_shopify_next_invoice / 100 : 0;

      state.shopify.subscription = {
        status: stripe_shopify_subscription_status.toLowerCase() as EStripeSubStatus,
        planName: subscription_type === 'pro_plan' ? EGithubPlanNames.PRO : EGithubPlanNames.ESSENTIAL,
        isAnnual,
        finishDate: stripe_shopify_subscription_current_period_end ? new Date(Number(stripe_shopify_subscription_current_period_end + '000')).toLocaleDateString() : null,
        finishDateInMillisecond:Number(stripe_shopify_subscription_current_period_end + '000'),
        cost: cost as number,
        quantity: (stripe_shopify_orders_bought_quantity || 0) - (stripe_shopify_orders_quantity || 0) || availableItemsQuantity,
        addedItemsQuantity: addedItemsQuantity || 0,
        payItemsQuantity: stripe_shopify_orders_bought_quantity || ordersPrevMonth,
        planQuantity: stripe_shopify_orders_bought_quantity || stripe_shopify_orders_quantity,
        isInvoiceRequested: stripe_shopify_subscription_bank_transfer_requested || false,
        isCancel: stripe_shopify_subscription_cancel_at_period_end || false,
        subscription_type: subscription_type || null
      };
    } else if (stripe_shopify_subscription_status) {
      state.shopify.subscription = {
        status: stripe_shopify_subscription_status.toLowerCase() as EStripeSubStatus,
        addedItemsQuantity: addedItemsQuantity,
        payItemsQuantity: ordersPrevMonth,
        cost: 0,
      };
    }
  }
}
